import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { fetchUserSettingsPage } from 'app/api/account-settings-api';
import { baseMapStateToProps, baseMapDispatchToProps, basePreload } from 'app/common/containers/base';
import { fetchAddressCountries } from 'app/common/api/common-api';
import { preloadSubscriptions } from 'app/containers/settings/subscriptions-utils';
import SettingsApp from 'app/components/root-apps/settings-app';

const mapStateToProps = (state, ownProps) => ({
  ...baseMapStateToProps(state, ownProps),
});

const AppContainer = connect(mapStateToProps, baseMapDispatchToProps)(preload(
  ({ dispatch, getState }) => Promise.all(
    [
      dispatch(fetchUserSettingsPage()),
      dispatch(fetchAddressCountries()),
      ...basePreload(dispatch, getState()),
    ])
    // Need this to happen after we have user info
    .then(() => Promise.all(preloadSubscriptions(getState(), dispatch))),
)(SettingsApp),
);

export default AppContainer;



// WEBPACK FOOTER //
// ./app/containers/root-apps/settings-app.js